import React from 'react';
import { MainSlopePoints } from '../../../../../../../../core/types/types';
import { Polyline } from 'react-leaflet';
import { theme } from '../../../../../../../../core/theme/theme';

interface MainSlopeLineProps {
    mainSlopePoints: MainSlopePoints;
}
const MainSlopeLine: React.FC<MainSlopeLineProps> = ({ mainSlopePoints }) => {
    return (
        <Polyline
            positions={[
                { lat: mainSlopePoints.highest.lat, lng: mainSlopePoints.highest.lng },
                { lat: mainSlopePoints.lowest.lat, lng: mainSlopePoints.lowest.lng },
            ]}
            dashArray="10"
            weight={2}
            color={theme.colors.main_slope_color}
        />
    );
};

export default MainSlopeLine;
